import { CaretRight } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import MemberPermissionsTag from "common/components/MemberPermissionsTag";
import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import { Button } from "common/components/ui/Button";
import { Dialog, OverlayDialogContent } from "common/components/ui/Dialog";
import ProfileImage from "common/components/ui/ProfileImage";
import type { Member } from "common/types";

import MobileMemberDetails from "./MobileMemberDetails";

export default function MobileList({ members }: { members: Member[] }) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState<Member>(null);

  const handleRowClick = (member: Member) => {
    setSelectedMember(member);
    setIsDetailsOpen(true);
  };

  return (
    <>
      <div className="mt-4 flex justify-between rounded-2xl bg-black-100 px-4 py-2">
        <span className="text-xs">Member's name</span>
        <span className="pr-20 text-xs">Role</span>
      </div>

      <div className="mt-2 flex flex-col gap-2">
        {members.map((member) => {
          const {
            token,
            first_name: firstName,
            last_name: lastName,
            role,
            email,
            permissions,
            status,
          } = member;

          return (
            <button
              key={token}
              type="button"
              className="flex items-center justify-between gap-4 rounded-3xl border border-black-200 p-3"
              onClick={() => handleRowClick(member)}
            >
              <div className="flex flex-1 flex-row items-center gap-2">
                {status === "pending" ? (
                  <ProfileImage src="" />
                ) : (
                  <AimfoxAvatar firstName={firstName} lastName={lastName} />
                )}

                <div className="flex flex-col justify-center gap-0.5">
                  <span
                    className={clsx(
                      "line-clamp-1 break-all text-start text-sm-bold",
                      status === "pending" && "text-black-400",
                    )}
                  >
                    {status === "pending"
                      ? `New ${role === "member" ? "Member" : "Admin"}`
                      : `${firstName} ${lastName}`}
                  </span>

                  <span
                    className={clsx(
                      "line-clamp-1 break-all text-start text-xs-medium text-black-400",
                      status === "pending"
                        ? "text-black-400"
                        : "text-black-500",
                    )}
                  >
                    {email}
                  </span>
                </div>
              </div>

              <MemberPermissionsTag role={role} permissions={permissions} />

              <Button intent="labelIcon" asChild variant="ghost-black">
                <CaretRight />
              </Button>
            </button>
          );
        })}
      </div>

      <Dialog open={isDetailsOpen} onOpenChange={setIsDetailsOpen}>
        <OverlayDialogContent>
          <MobileMemberDetails member={selectedMember} />
        </OverlayDialogContent>
      </Dialog>
    </>
  );
}
